import { IRoleOptionsState } from './role-options.state';
import { createReducer, on } from '@ngrx/store';
import {
  loadRoleOptions,
  loadRoleOptionsSuccess,
} from './role-options.actions';

export const initialState: IRoleOptionsState = {
  roleOptions: [],
  roleOptionsLoading: false,
};

export const roleOptionsReducer = createReducer(
  initialState,
  on(loadRoleOptions, (state) => {
    return {
      ...state,
      roleOptionsLoading: true,
    };
  }),
  on(loadRoleOptionsSuccess, (state, { roleOptions }) => {
    return {
      ...state,
      roleOptions,
      roleOptionsLoading: false,
    } as IRoleOptionsState;
  })
);
